"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BupaConfig = void 0;
var _bupaThemeContext = require("./bupaThemeContext");
var _bupaCustomRouteDefinitions = require("./quoteTools/bupaCustomRouteDefinitions");
var _defaultIcons = require("../../defaults/productTable/defaultIcons");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultAuthorisedPersonDisplaySettings = require("../../defaults/quoteTools/defaultAuthorisedPersonDisplaySettings");
var _defaultRegularVetDisplaySettings = require("../../defaults/quoteTools/defaultRegularVetDisplaySettings");
var _defaultSummary = require("../../defaults/quoteTools/defaultSummary");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _defaultQuoteToolContext = require("../../defaults/quoteTools/defaultQuoteToolContext");
var _defaultStepDefinitions = require("../../defaults/quoteTools/defaultStepDefinitions");
var _defaultAboutOwner = require("../../defaults/quoteTools/defaultAboutOwner");
var _defaultAboutPet = require("../../defaults/quoteTools/defaultAboutPet");
var _defaultCoverDisplayOptions = require("../../defaults/quoteTools/defaultCoverDisplayOptions");
var _defaultSuccess = require("../../defaults/quoteTools/defaultSuccess");
var _bupaQuoteToolContext = require("./quoteTools/bupaQuoteToolContext");
var _bupaStepsDefinitions = require("./quoteTools/bupaStepsDefinitions");
var _defaultPayment = require("../../defaults/quoteTools/defaultPayment");
var _bupaSuccess = require("./quoteTools/bupaSuccess");
var BupaConfig = exports.BupaConfig = {
  theme: _bupaThemeContext.BupaThemeContext,
  quoteTools: {
    themeOverrides: _defaultQuoteToolContext.DefaultQuoteToolContext,
    steps: {
      StepDefinitions: _bupaStepsDefinitions.BupaStepDefinitions,
      basicOwnerDetails: _bupaQuoteToolContext.bupaBasicOwnerDetails,
      fullOwnerDetails: _defaultAboutOwner.DefaultAboutOwner,
      aboutPet: _defaultAboutPet.DefaultAboutPet,
      coverDisplayOptions: _defaultCoverDisplayOptions.DefaultCoverDisplayOptions,
      summary: _defaultSummary.DefaultSummary,
      success: _bupaSuccess.BupaSuccess,
      payment: _defaultPayment.defaultPayment,
      bannerStyle: 'bullets',
      showCompletedStepBannerOnPage: 'step6'
    },
    widgets: {
      authorisedPersonDisplaySettings: _defaultAuthorisedPersonDisplaySettings.defaultAuthorisedPersonDisplaySettings,
      regularVetDisplaySettings: _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings
    },
    customRouteDefinitions: _bupaCustomRouteDefinitions.BupaCustomRouteDefinitions,
    staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
    productTable: {
      optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
      staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
      icons: _defaultIcons.defaultIcons
    },
    middlewareApiKeys: {
      "public": {
        sit: {
          applicationId: '406F94A4-AF1F-46CC-A1D3-5DA77288D826',
          apiKey: '3JA3BBEAC950624EC5B',
          expiry: 3600
        },
        uat: {
          applicationId: '406F94A4-AF1F-46CC-A1D3-5DA77288D826',
          apiKey: '3JA3BBEAC950624EC5B',
          expiry: 3600
        },
        preprod: {
          applicationId: 'C4136433-BB98-4223-902B-857262267038',
          apiKey: '4828FBCA8498430CB5',
          expiry: 3600
        },
        prod: {
          applicationId: '3C221788-828A-4EFA-8E2F-29DDD3AD6BDB',
          apiKey: '1DD491486969442DA6',
          expiry: 3600
        }
      },
      staff: {
        sit: {
          applicationId: '5F141139-F908-42D3-BC34-29A5FC5D89AB',
          apiKey: '3UA6D0EF45F9A24A9E9',
          expiry: 3600
        },
        uat: {
          applicationId: '5F141139-F908-42D3-BC34-29A5FC5D89AB',
          apiKey: '3UA6D0EF45F9A24A9E9',
          expiry: 3600
        },
        preprod: {
          applicationId: '405E3B8E-2665-421B-8F9E-82197961285A',
          apiKey: 'D56D2354A4A94DA7A7',
          expiry: 3600
        },
        prod: {
          applicationId: '31674305-ECA6-4CA1-B2F5-6EA3DB3E751D',
          apiKey: '2FDD0377C3B042FC84',
          expiry: 3600
        }
      }
    },
    recaptchaSiteKey: '6LdZBvwkAAAAABwqPT8cJVp-QBffDvM_vYelEb0b',
    recaptchaSecretKey: '6LdZBvwkAAAAAPhTfu_EtxKs04qApinHSKtU3MXY',
    recaptchaSiteKeyProd: '6LcnBfwkAAAAAIYQJea0P6wAnR5efUOV447A2lXr',
    recaptchaSecretKeyProd: '6LcnBfwkAAAAALquAApwSK-HI3kIjvagBjmqvd6K'
  }
};